// import emoji from '@assets/images/emoji.png'

// customPlugin.js
export default editor => {
  editor.on('init', () => {
    // 注册多种高亮格式
    const highlightFormats = {
      highlightWavy: { name: 'highlightWavy', title: '波浪线', class: 'cus-highlight-wavy' },
      highlightSpecial: {
        name: 'highlightSpecial',
        title: '特殊四边形',
        class: 'cus-highlight-special',
      },
      highlightEllipse: {
        name: 'highlightEllipse',
        title: '椭圆背景',
        class: 'cus-highlight-ellipse',
      },
      highlightParallelogram: {
        name: 'highlightParallelogram',
        title: '平行四边形',
        class: 'cus-highlight-parallelogram',
      },
      highlightCircle: {
        name: 'highlightCircle',
        title: '圆圈下划线',
        class: 'cus-highlight-circle',
      },
    }
    // 注册所有格式
    Object.values(highlightFormats).forEach(format => {
      editor.formatter.register(format.name, {
        inline: 'span',
        classes: format.class,
        attributes: { 'data-highlight-type': format.name },
      })
    })

    // 添加自定义按钮
    editor.ui.registry.addSplitButton('highlightPicker', {
      icon: 'underline',
      tooltip: '高亮样式',
      select: value => {
        return editor.formatter.match(value)
      },
      fetch: callback => {
        const arr = Object.entries(highlightFormats).map(([name, format]) => ({
          type: 'choiceitem',
          text: format.title,
          class: format.class,
          value: name,
        }))
        callback(arr)
      },
      onAction: () => {
        const highlightItem = Object.values(highlightFormats).find(item => {
          return editor.formatter.match(item.name)
        })
        if (highlightItem) {
          editor.execCommand('mceToggleFormat', false, highlightItem.name)
        } else {
          editor.execCommand('mceToggleFormat', false, 'highlightWavy')
        }
      },
      onItemAction: (api, value) => {
        if (value === 'remove') {
          editor.formatter.remove('highlightWavy')
        } else {
          const format = highlightFormats[value]
          editor.execCommand('mceToggleFormat', false, format.name)
        }
      },
      // onAction: () => {
      //   // 注册高亮格式
      //   editor.formatter.register('highlightFormat', {
      //     inline: 'span',
      //     classes: 'cus-highlight',
      //   })

      //   // 应用格式到选区
      //   editor.execCommand('mceToggleFormat', false, 'highlightFormat')
      // },
    })

    return {
      getMetadata: () => ({
        name: 'Custom Highlight',
        url: 'https://example.com',
      }),
    }
  })
}
